module.exports = __webpack_public_path__ + "img/bg-kj-1.f10be781.jpg";